<!--商品分类组件-->
<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item >商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品分类</el-breadcrumb-item>
    </el-breadcrumb>

    <!--添加分类按钮区域-->
      <el-row :gutter="20" class="search">
        <el-col :span="8">
          <el-input placeholder="请输入查找的商品分类">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button @click="showCategory" type="primary">添加分类</el-button>
        </el-col>
      </el-row>

    <!--商品分类表格区域-->
    <el-table  border :data="categories" row-key="id" stripe
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}" >
      <el-table-column prop="id" label="编号" align="center" ></el-table-column>
      <el-table-column prop="className" label="分类名称"  align="center"></el-table-column>
      <el-table-column prop="level" label="分类等级" align="center">
        <template scope="scope">
          <el-tag v-if="scope.row.level == '1'">一级分类</el-tag>
          <el-tag v-if="scope.row.level == '2'" type="success">二级分类</el-tag>
          <el-tag v-if="scope.row.level == '3'" type="warning">三级分类</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px" align="center">
        <el-button type="primary" icon="el-icon-edit">编辑</el-button>
        <el-button type="danger" icon="el-icon-delete">删除</el-button>
      </el-table-column>
    </el-table>

    <!--分页器区域-->

    <!--弹出表单-->
    <el-dialog class="form-dialog" title="添加分类" :visible.sync="dialogFormVisible">
      <el-form class="categoryForm" :model="form">
        <el-form-item label="一级分类">
          <el-select v-model="form.level1" placeholder="请选择一级分类项">
            <el-option label="种植作物" value="zhongzhi"></el-option>
            <el-option label="加工制品" value="jiagong"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类">
          <el-select v-model="form.level2" placeholder="请选择二级分类项">
            <el-option label="粮食作物" value="liangshi"></el-option>
            <el-option label="其他杂粮" value="qitazaliang"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="三级分类">
          <el-select v-model="form.level3" placeholder="请选择三级分类项">
            <el-option label="禾谷类" value="hegu"></el-option>
            <el-option label="薯类" value="shulei"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import classes from './../../assets/json/classes.json'
export default {
  name: 'Categories',
  data () {
    return {
      dialogFormVisible: false, // 表单是否可见
      categories: classes.dataList, // 分类列表
      form: { // 分类表单
        level1: '', // 一级分类
        level2: '', // 二级分类
        level3: ''// 三级分类
      }
    }
  },
  methods: {
    showCategory () { // 显示添加分类表单
      this.dialogFormVisible = true
    },
    cancelSubmit () { // 取消
      this.dialogFormVisible = false// 隐藏对话框
      // 清空状态
      this.form = { // 分类表单
        level1: '', // 一级分类
        level2: '', // 二级分类
        level3: ''// 三级分类
      }
    },
    onSubmit () {
      this.dialogFormVisible = false// 隐藏对话框
      console.log('表单提交了')
      console.log(this.form)

      // 清空状态
      this.form = { // 分类表单
        level1: '', // 一级分类
        level2: '', // 二级分类
        level3: ''// 三级分类
      }
    }
  }
}
</script>

<style scoped>
.search{
  margin-bottom: 30px;
}

</style>
